// extracted by mini-css-extract-plugin
export default {"wrapper":"SpotifyPlayer_wrapper__3aFTn","fadeIn":"SpotifyPlayer_fadeIn__mzswK","loader":"SpotifyPlayer_loader__BboOZ"};